<template>
    <div class="row p-0">
        <div class="col-6" v-if="shouldShowFilter('supplier')">
            <div class="mb-3">
                <label class="form-label">{{ getFilterLabel('supplier') }}</label>
                <v-select
                    :options="proveedores"
                    v-model="supplier"
                    :reduce="proveedor => proveedor"
                    :placeholder="`Seleccionar ${getFilterLabel('supplier').toLowerCase()}`"
                    class="custom-v-select"
                    :clearable="true"
                    @input="onClearSelect('supplier', $event)"
                />
            </div>
        </div>
        <div class="col-6" v-if="shouldShowFilter('brand')">
            <div class="mb-3">
                <label class="form-label">{{ getFilterLabel('brand') }}</label>
                <v-select
                    :options="marcas"
                    v-model="brand"
                    :reduce="marca => marca"
                    :placeholder="`Seleccionar ${getFilterLabel('brand').toLowerCase()}`"
                    class="custom-v-select"
                    :clearable="true"
                    @input="onClearSelect('brand', $event)"
                />
            </div>
        </div>
        <div class="col-6" v-if="shouldShowFilter('select_category')">
            <div class="mb-3">
                <label class="form-label">{{ getFilterLabel('select_category') }}</label>
                <filter-categories @getData="getCategory" class="custom-select" :category="select_category"/>
            </div>
        </div>
        <div class="col-6" v-if="shouldShowFilter('product_group')">
            <div class="mb-3">
                <label class="form-label">{{ getFilterLabel('product_group') }}</label>
                <v-select
                    :options="groups"
                    v-model="product_group"
                    :reduce="group => group"
                    :placeholder="`Seleccionar ${getFilterLabel('product_group').toLowerCase()}`"
                    class="custom-v-select"
                    :clearable="true"
                    @input="onClearSelect('product_group', $event)"
                />
            </div>
        </div>
        <div class="col-6" v-if="shouldShowFilter('product_type')">
            <div class="mb-3">
                <label class="form-label">{{ getFilterLabel('product_type') }}</label>
                <v-select
                    :options="filtros"
                    v-model="product_type"
                    :reduce="filtro => filtro"
                    :placeholder="`Seleccionar ${getFilterLabel('product_type').toLowerCase()}`"
                    class="custom-v-select"
                    :clearable="true"
                    @input="onClearSelect('product_type', $event)"
                />
            </div>
        </div>
        <div class="col-6" v-if="authentication_user.client !== 22 && shouldShowFilter('cluster') && authentication_user.active_store">
            <div class="mb-3">
                <label class="form-label">{{ getFilterLabel('cluster') }}</label>
                <v-select
                    :options="clusters"
                    v-model="cluster"
                    label="name"
                    :reduce="cluster => cluster.name"
                    :placeholder="`Seleccionar ${getFilterLabel('cluster').toLowerCase()}`"
                    class="custom-v-select"
                    :clearable="true"
                    @input="onClearSelect('cluster',$event)"
                />
            </div>
        </div>
        <div class="d-flex justify-content-end gap-2">
            <button class="btn bgc-dark text-white fw-400" @click="close()">Cerrar</button>
            <button class="btn btn-primary fw-400" @click="cleanFilters()">Limpiar filtros</button>
            <button class="btn btn-success fw-400" @click="applyFilters">
                Aplicar filtros
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import FilterCategories from "../../../../components/categories/index.vue";
import vSelect from 'vue-select';
export default {
    name: 'filter-configs-rec',
    components: {
        FilterCategories,
        vSelect
    },
    props: {
        propHead: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            marcas: [],
            proveedores: [],
            groups: [],
            filtros: [],
            clusters: [],
            select_category: null,
            supplier: '',
            brand: '',
            product_type: '',
            product_group: '',
            product_status: '',
            cluster: '',
        }
    },
    computed: {
        ...mapGetters(["authentication_user"]),
        ...mapState({
            filters: state => state.filters.filters
        })
    },
    created() {
        this.getFilterProveedor();
        this.getFilterMarca();
        this.getFilterOther();
        this.getFilterGroup();
        this.getFiltersSelected();
        this.getFilterCluster();
    },
    methods: {
        ...mapActions(["get", "executeCommit"]),
        ...mapMutations(['set_filters', 'reset_filters']),
        applyFilters() {
            this.set_filters({
                supplier: this.supplier,
                brand: this.brand,
                product_type: this.product_type,
                product_group: this.product_group,
                product_status: this.product_status,
                select_category: this.select_category,
                cluster: this.cluster
            });
            this.$emit('applyFilters');
        },
        getCategory(row) {
            this.select_category = row.category;
        },
        getFilterMarca() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_5`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.marcas = response.results;
            });
        },
        getFilterProveedor() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_1`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.proveedores = response.results;
            });
        },
        getFilterGroup() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_4`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.groups = response.results;
            });
        },
        getFilterOther() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_2`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.filtros = response.results;
            });
        },
        close() {
            this.executeCommit({ mutation: "close_modal" });
            this.$emit("refrest");
        },
        cleanFilters() {
            this.supplier = '';
            this.brand = '';
            this.product_type = '';
            this.product_group = '';
            this.product_status = '';
            this.select_category = null;
            this.cluster = '';
            this.reset_filters();
        },
        getFiltersSelected() {
            const storeFilters = this.filters;
            const localKeys = [
                'supplier',
                'brand',
                'product_type',
                'product_group',
                'product_status',
                'select_category',
                'cluster'
            ];
            localKeys.forEach(key => {
                if (Object.prototype.hasOwnProperty.call(storeFilters, key)) {
                    this[key] = storeFilters[key];
                }
            });
        },
        onClearSelect(filterName, val) {
            if (!val) {
                switch (filterName) {
                    case 'product_group':
                        this.product_group = '';
                        break;
                    case 'supplier':
                        this.supplier = '';
                        break;
                    case 'brand':
                        this.brand = '';
                        break;
                    case 'product_type':
                        this.product_type = '';
                        break;
                    case 'cluster':
                        this.cluster = '';
                        break;
                    default:
                        break;
                }
            }
        },
        getFilterLabel(key) {
            if (!this.authentication_user.client_filters ||
                !this.authentication_user.client_filters.filters ||
                !Array.isArray(this.authentication_user.client_filters.filters) ||
                this.authentication_user.client_filters.filters.length === 0) {
                return this.getDefaultLabel(key);
            }
            const filter = this.authentication_user.client_filters.filters.find(f => f && f.key === key);
            return filter?.label || this.getDefaultLabel(key);
        },
        shouldShowFilter(key) {
            if (!this.authentication_user.client_filters ||
                !this.authentication_user.client_filters.filters ||
                !Array.isArray(this.authentication_user.client_filters.filters) ||
                this.authentication_user.client_filters.filters.length === 0) {
                return true;
            }
            const filter = this.authentication_user.client_filters.filters.find(f => f && f.key === key);
            return filter?.show !== false;
        },
        getDefaultLabel(key) {
            const defaultLabels = {
                'product_group': 'Grupo de productos',
                'supplier': 'Proveedor',
                'brand': 'Marca',
                'select_category': 'Categorías',
                'product_type': 'Tipo de producto',
                'product_status': 'Estado de producto',
                'cluster': 'Lista de precios',
            };
            return defaultLabels[key] || key;
        },
        getFilterCluster(){
            this.get({
                url: `/api/stores/?page_size=100`
            }).then((response) => {
                this.clusters = response.results
            })
        },
    }
}
</script>

<style scoped>
.custom-select {
    border-radius: 6px;
    height: 40px;
    font-size: 14px;
}
.form-label {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 6px;
}
.btn-secondary {
    background-color: #6C757D !important;
    padding: 8px 15px !important;
}
.btn-success {
    background-color: #1AA179 !important;
}
</style>
